import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserService } from '../service/user.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Log } from '../util/log';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  @ViewChild('loader', { static: true }) loader;

  showDevices: boolean = true;

  constructor(
    private userService: UserService,
    private appComponent: AppComponent,
    private router: Router
  ) {

  }

  async ngOnInit() {

    this.loader.showLoading();

    const isAlias = await this.appComponent.isAlias();

    if (isAlias) {

      const homePage = await this.userService.checkAliasHomePage();

      if (homePage) {
        if (homePage === "DeviceView") {
          this.router.navigate(['devices/']);
        } else if (homePage === "UserView") {
          this.router.navigate(['users/']);
        } else if (homePage === "GroupView") {
          this.router.navigate(['groups/']);
        } else if (homePage === "ExecutionView") {
          this.router.navigate(['executions/']);
        } else if (homePage === "OperationView") {
          this.router.navigate(['operationLog/']);
        } else if (homePage === "AliasView") {
          this.router.navigate(['aliases/']);
        } else if (homePage === "accept-requests") {
          this.router.navigate(['requests/']);
        }else {
          Log.debug("no correspondant homepage found")
        }
      } else {
          Log.debug("no homepage found")
        this.router.navigate(['devices/']);
      }
    }
    else {
      // not alias, go to devices
      setTimeout(() => {
        this.router.navigate(['devices/']);
      });

    }
  }
}
